// 10級パッケージの5級
type ckptTypeForGrade_5_20kyu =
  | 'よい姿勢'
  | '足を体の前で回す'
  | '足のつき方'
  | 'うで振り'
  | 'スピードを出す';

// ここから下をいじる！

export const ckptForGrade_5_20kyu: ckptTypeForGrade_5_20kyu[] = [
  'よい姿勢',
  '足を体の前で回す',
  '足のつき方',
  'うで振り',
  'スピードを出す',
];

export const requirement_5_20kyu: ckptTypeForGrade_5_20kyu[] = [
  'よい姿勢',
  '足を体の前で回す',
];

export type ckptDetails_5_20 =
  | '前後傾'
  | '下に踏む'
  | '足の上がり'
  | '接地様式'
  | 'うで振り'
  | 'スピードが出せている'
  | '腰が落ちていない'
  // 採点用
  | '後ろに蹴っていない';

type allCheckpoints_5_20kyu_type = {
  [key in ckptTypeForGrade_5_20kyu]: ckptDetails_5_20[];
};

export const allCheckPoints_5_20kyu: allCheckpoints_5_20kyu_type = {
  よい姿勢: ['前後傾', '腰が落ちていない'],
  足を体の前で回す: ['足の上がり', '下に踏む'],
  足のつき方: ['接地様式'],
  うで振り: ['うで振り'],
  スピードを出す: ['スピードが出せている'],
};

export const borderLine_5_20kyu: allCheckpoints_5_20kyu_type = {
  よい姿勢: ['前後傾'],
  足を体の前で回す: ['足の上がり'],
  足のつき方: ['接地様式'],
  うで振り: ['うで振り'],
  スピードを出す: ['スピードが出せている'],
};
